/* eslint-disable */
const getters = {
  getCheckoutMethod(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
